import { useTextes } from '@common/config';
import { useSessionContext } from '@common/hooks';
import { useSelectedCampagne } from '@common/hooks/campagne';
import { CampagneStatut, OrganismeProjection, useGetOrganismeQuery } from '@common/services';
import { OfaMessageBanner } from '@common/ui';
import React, { useState } from 'react';
import { OfaCampagneSelect } from '../../components/OfaCampagneSelect';
import { CampagneDepots } from './components/CampagneDepots/CampagneDepots';
import { CampagneDocuments } from './components/CampagneDocument/CampagneDocuments';
import { CampagneInformations } from './components/Informations/CampagneInformations';
import { SuiviDepot } from './components/SuiviDepot/SuiviDepot';

export const Campagne = () => {
  const t = useTextes('Commun', 'Campagne');

  const { organismeId, accessHistory } = useSessionContext();
  const { selectedCampagne, setSelectedCampagneYear } = useSelectedCampagne();

  const [selectedOrganismeId, setSelectedOrganismeId] = useState<number>(organismeId);

  const { data: organisme } = useGetOrganismeQuery({ id: selectedOrganismeId, projection: OrganismeProjection.STATUT });

  const handleYearChange = (year: number) => {
    setSelectedCampagneYear(year);
    const access = accessHistory.find((a) => a.campagneAnnee === year);
    if (access) setSelectedOrganismeId(access.organismeId);
  };

  if (!selectedCampagne || !organisme) return null;

  const isCampagneArchived = (selectedCampagne.statut === CampagneStatut.ARCHIVEE);

  return (
    <div className={'flex flex-col gap-6'}>

      <OfaCampagneSelect onYearChange={handleYearChange} />

      {isCampagneArchived && (
        <OfaMessageBanner title={t['CAMPAGNE_TERMINEE_MSG1']}
                          subtitle={organisme.depotProlonge
                            ? t['CAMPAGNE_TERMINEE_MSG2']
                            : t['CAMPAGNE_TERMINEE_MSG3']} />
      )}

      <CampagneInformations annee={selectedCampagne.annee}
                            dateDebutInscription={selectedCampagne.dateDebutInscription}
                            dateOuvertureDepot={selectedCampagne.dateOuvertureDepot}
                            dateClotureDepot={selectedCampagne.dateClotureDepot} />

      <div className={'flex flex-col md:flex-row gap-6'}>
        <div className={'fr-card md:w-1/2'}>
          <CampagneDocuments campagneId={selectedCampagne.id} organismeId={organisme.id} />
        </div>

        <div className={'fr-card md:w-1/2'}>
          <CampagneDepots campagneAnnee={selectedCampagne.annee} organismeId={organisme.id} />
        </div>
      </div>

      <div className={'fr-card md:w-full'}>
        <SuiviDepot campagneAnnee={selectedCampagne.annee} organismeId={organisme.id} />
      </div>
    </div>
  );
};